import { Outlet } from "react-router-dom";
import Header from "../components/header";
import AuthGuard from "./AuthGuard";
import Footer from "../components/Footer";
import { Roles } from "../constants";

function GuestRoutes() {
  return (
    <>
      <AuthGuard role={Roles.GUEST}>
        <Header />
        <Outlet />
        <Footer />
      </AuthGuard>
    </>
  );
}
export default GuestRoutes;
